/*
 * File: d:\projects\AutoFiFront\src\Theme\ProgressBarCustom.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday March 14th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday March 14th 2023 2:29:40 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styled from "styled-components";
import { getThemeColor } from "Utils/ThemeColor";

const ProgressBarCustom = styled.span.attrs((props: any) => ({
    barColor: props.barColor,
    bgColor: props.bgColor
}))`
.MuiMobileStepper,
.MuiPaper-root {
    background-color: ${(props: any) => props.barColor} !important;
    background: ${props => props.barColor} !important;
    border-radius: 5px;
}
.MuiLinearProgress-root{
    width: 100% !important;
    background-color: ${(props: any) => getThemeColor(`${props.barColor}-light`)} !important;
}

.MuiLinearProgress-bar{
    background-color: ${(props: any) => getThemeColor(props.barColor)} !important;
}
`;

export default ProgressBarCustom;
